__turbopack_context__.v({
  "addressLine": "Footer-module__rnk_JG__addressLine",
  "btnWrap": "Footer-module__rnk_JG__btnWrap",
  "container": "Footer-module__rnk_JG__container",
  "copy": "Footer-module__rnk_JG__copy",
  "copyPatron": "Footer-module__rnk_JG__copyPatron",
  "copySelect": "Footer-module__rnk_JG__copySelect",
  "fadeInItems": "Footer-module__rnk_JG__fadeInItems",
  "link": "Footer-module__rnk_JG__link",
  "links": "Footer-module__rnk_JG__links",
  "rotateBtn": "Footer-module__rnk_JG__rotateBtn",
  "row": "Footer-module__rnk_JG__row",
  "rowCopy": "Footer-module__rnk_JG__rowCopy",
  "scrollTopBtn": "Footer-module__rnk_JG__scrollTopBtn",
  "spacing--lg": "Footer-module__rnk_JG__spacing--lg",
  "spacing--md": "Footer-module__rnk_JG__spacing--md",
  "spacing--sm": "Footer-module__rnk_JG__spacing--sm",
  "spacing--xl": "Footer-module__rnk_JG__spacing--xl",
  "spacing--xs": "Footer-module__rnk_JG__spacing--xs",
  "spacing--xxl": "Footer-module__rnk_JG__spacing--xxl",
  "spacing--xxs": "Footer-module__rnk_JG__spacing--xxs",
  "spacing--xxxl": "Footer-module__rnk_JG__spacing--xxxl",
  "spacing--xxxs": "Footer-module__rnk_JG__spacing--xxxs",
  "wrapper": "Footer-module__rnk_JG__wrapper",
});
